import { Card, Layout } from "@certn/cascadia-react";
import { PrimaryButton, Stack, Text } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { css } from "@emotion/css";

import { LogoHeader } from "../../components/LogoHeader";
import { useUser } from "../../hooks/api/useUser";
import { AppHeader } from "../../components/app-header";
import { AppFooter } from "../../components/app-footer";

export function ReportAccessDenied() {
  const { t } = useTranslation();
  const { user } = useUser();
  const navigate = useNavigate();

  return (
    <Layout
      layout="applicant/narrow"
      header={<AppHeader />}
      footer={<AppFooter />}
    >
      <Card border="none" className={styles.card}>
        <Stack gap="space-6">
          <LogoHeader
            title={t("Report Access Restricted")}
            subtitle={t("You do not have permission to view this report.")}
          />
          <Stack align="center">
            <PrimaryButton size="large" onPress={() => navigate("/")}>
              {t("Return to Dashboard")}
            </PrimaryButton>
            <Text>
              {t("You are currently signed in as")} {user?.email}.
            </Text>
          </Stack>
        </Stack>
      </Card>
    </Layout>
  );
}

const styles = {
  card: css({
    maxWidth: "400px",
    margin: "0 auto",
  }),
};
